import { WIZE_SUBSCRIPTION_NAME } from 'my-core/constants';
import { hasCourseBundleAccess } from 'my-core/course-utils';
import { isStudySessionUserRegistered } from 'my-core/study-session-utils';
import { getIsActiveOrTrialing } from 'my-core/subscription-utils';

import LoginProtected from 'my-components/LoginProtected';

import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

import { faBadgeCheck, faBan } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function StudySessionCardActionButton({
  ButtonProps,
  // course,
  courseSubscription,
  isExpired,
  loading,
  loginRedirect,
  onRegister,
  onRegisterFree,
  onSubscribeCheckout,
  studySession,
  studySessionFreeRegisterStatus,
  subscription,
  userCourse,
}) {
  const studySessionUser = studySession?.current_user_study_session_user;

  const registered = isStudySessionUserRegistered(studySessionUser);
  const isPurchaseRequired = studySession?.purchase_type === 'standard' && !!studySession.price;
  const isSubscriptionRequired = studySession?.purchase_type === 'subscription' && !getIsActiveOrTrialing(subscription);

  if (isExpired) {
    return (
      <Typography
        align="center"
        sx={{
          color: 'text.secondary',
        }}
        variant="subtitle2"
      >
        <FontAwesomeIcon icon={faBan} />
        Expired
      </Typography>
    );
  }
  if (registered) {
    return (
      <Typography
        align="center"
        sx={{
          color: 'text.secondary',
        }}
        variant="subtitle2"
      >
        <FontAwesomeIcon icon={faBadgeCheck} />{' '}
        {registered ?
          isPurchaseRequired ?
            'Purchased'
          : 'Registered'
        : 'No Registration Required'}
      </Typography>
    );
  }

  const buttonDisabled = !!loading || studySessionFreeRegisterStatus?.fetching;

  const ctaProps = getCTAProps();

  const btn = (
    <Button
      variant="contained"
      {...ButtonProps}
      className={ButtonProps?.className}
      disabled={buttonDisabled || !!ctaProps.disabled}
      onClick={ctaProps.onClick}
    >
      {ButtonProps?.children ||
        (isPurchaseRequired ? 'Purchase'
        : isSubscriptionRequired ? 'Subscribe'
        : 'Register for Free')}
    </Button>
  );

  if (ctaProps.disabled) {
    return (
      <Tooltip title={ctaProps.tooltip}>
        <span>{btn}</span>
      </Tooltip>
    );
  }

  return (
    <LoginProtected
      actionText="Register"
      messagingProduct="live-prep"
      // checkout={isPurchaseRequired ? studySession.id : undefined}
      redirect={loginRedirect}
      source="live_prep_signup"
      // toSignupPage={isPurchaseRequired ? { course_id: course?.id } : true}
    >
      {btn}
    </LoginProtected>
  );

  function getCTAProps() {
    switch (studySession?.purchase_type) {
      case 'subscription': {
        return {
          onClick: isSubscriptionRequired ? onSubscribeCheckout : () => onRegisterFree(studySession.id),
          disabled: !!(isSubscriptionRequired && !onSubscribeCheckout),
          tooltip: `Purchase the ${WIZE_SUBSCRIPTION_NAME} subscription to register`,
        };
      }
      case 'course_bundle': {
        const coursePurchased = hasCourseBundleAccess(userCourse, courseSubscription);

        return {
          disabled: !coursePurchased,
          onClick: () => onRegisterFree(studySession.id),
          tooltip:
            (
              userCourse?.status === 'pending_payment' && userCourse?.lsac_info.subscription_type === 'Prep' // LSAT specific handling
            ) ?
              'LSAC account required to register'
            : 'Course purchase required',
        };
      }
    }
    return {
      onClick: isPurchaseRequired ? () => onRegister(studySession.id) : () => onRegisterFree(studySession.id),
    };
  }
}
